import { BaseResource } from "./base.resource";

export const GeneratorAccessLevel = {
  None: 0,
  View: 1 << 0,
  Edit: 1 << 1,
  Delete: 1 << 2,
};

export class Generator extends BaseResource {
  company: string;
  mailingAddress: string;
  emergencyPhone: string;
  name: string;
  phone: string;
  siteAddress: string;
  active: boolean;

  constructor(options?: any) {
    super(options);
    // Initialize properties...
  }

  get canView(): boolean {
    return (this.accessLevel & GeneratorAccessLevel.View) > 0;
  }
  get canEdit(): boolean {
    return (this.accessLevel & GeneratorAccessLevel.Edit) > 0;
  }
  get canDelete(): boolean {
    return (this.accessLevel & GeneratorAccessLevel.Delete) > 0;
  }
}
